import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const researchImporterSelectors = importerSelectors(
  'research.importer',
);

export default researchImporterSelectors;
